module.exports = __webpack_public_path__ + "img/Simulation-ConnectorTop.62bea307.jpeg";